import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useFormikContext} from 'formik';
import {get} from 'lodash';
import {Row, Col} from 'react-bootstrap';
import {BlackLinkButton} from '@styled';
import {MainLoader} from '@components';
import {sagaActions} from './redux/saga';

const OwnerDashboardCorporates = ({isActive}) => {
  const dispatch = useDispatch();
  const [isLoaded, setLoaded] = useState(false);
  const {values} = useFormikContext();
  const ownerCorporates = useSelector(
    (state) => state.dashboard.ownerCorporates
  );

  useEffect(() => {
    if (isActive) {
      setLoaded(true);
    }
  }, [isActive]);
  useEffect(() => {
    if (isLoaded) {
      dispatch({
        type: sagaActions.FETCH_OWNER_DASHBOARD_CORPORATES,
        payload: {
          values: {
            reportYear: get(values, 'reportYear.value', ''),
            sector: get(values, 'reportSector.value', ''),
            sourceCategory: get(values, 'sourceCategory.value', ''),
            emissionSource: get(values, 'emissionSource.value', ''),
            fuelType: get(values, 'fuelType.value', ''),
            country: get(values, 'country.value', ''),
          },
        },
      });
    }
  }, [isLoaded, values]);

  const handleCorporateSelect = (corporate) => {
    dispatch({type: sagaActions.SELECT_CORPORATE, payload: {corporate}});
  };

  return (
    <div>
      {ownerCorporates.loading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      <Row className="border-bottom mb-2 pb-2 font-weight-bold">
        <Col>Corporate</Col>
        <Col>Scope1 Emissions (t CO2)</Col>
        <Col>Scope2 Emissions (t CO2)</Col>
        <Col>Total Emissions (t CO2)</Col>
        <Col>Energy Consumed (MMBtu)</Col>
        <Col>Energy Produced (MMBtu)</Col>
        <Col>Energy Consumed Net (MMBtu)</Col>
        <Col>Reporting Year</Col>
      </Row>
      {!ownerCorporates.loading && ownerCorporates.data.length ? (
        ownerCorporates.data.map((rec) => {
          return (
            <Row key={rec.reportData.id} className="mb-2">
              <Col>
                <BlackLinkButton
                  variant="link"
                  size="sm"
                  onClick={() => handleCorporateSelect(rec.corporate)}
                >
                  {rec.corporate.name}
                </BlackLinkButton>{' '}
              </Col>
              <Col>{rec.scopeData.scopes.scope1}</Col>
              <Col>{rec.scopeData.scopes.scope2}</Col>
              <Col>{rec.scopeData.scopeTotal}</Col>
              <Col>{rec.scopeData.energyConsumed}</Col>
              <Col>{rec.scopeData.energyProduced}</Col>
              <Col>{rec.scopeData.netEnergyConsumed}</Col>
              <Col>{rec.reportData.reportYear}</Col>
            </Row>
          );
        })
      ) : (
        <Row>
          <Col>No data found!</Col>
        </Row>
      )}
    </div>
  );
};

export default OwnerDashboardCorporates;
